module.exports = __webpack_public_path__ + "static/media/auth.52ecff6c.svg";